import React, { useState, useEffect } from 'react';
import { useSharedTrialData } from '../../SharedHooks';
import DisplayButtons from '../recordButtons/DisplayButtons';
import RecordTimer from './RecordTimer';
import { TailSpin } from 'react-loader-spinner';
import GlobalOverlayPortal from '../../modals/GlobalOverlayPortal';

function RecordAssessment(props) {
    const { title, instructions, deferTimerUntilInit } = props;
    const [showInstructions, setShowInstructions] = useState(false);
    const { trialData, setTrialData } = useSharedTrialData();
    const [actions, setActions] = useState({
        record: false,
        resumeRecord: false
    });
    const [isInitializing, setInitializing] = useState(false);
    const [initError, setInitError] = useState(null);

    useEffect(() => {
        const { record, resumeRecord } = actions;
        if (record) {
          // If record is true, update the component's state
          setShowInstructions(false);
        } else if (resumeRecord) {
          // If resumeRecord is true, update the component's state
          setShowInstructions(true);
        }
      }, [actions]);

    // allows user to toggle instructions
    const toggleInstructions = () => setShowInstructions(!showInstructions);

    const onChangeNotes = e => {
        setTrialData({...trialData, [title]: {...trialData[title], notes: e.target.value}});
    }

    const initOverlay = deferTimerUntilInit && isInitializing && (
        <GlobalOverlayPortal>
            <div
                data-testid="init-cameras-overlay"
                className="app-global-overlay--fullscreen-backdrop"
            >
                <div style={{ textAlign: 'center' }}>
                    <TailSpin color="#ffffff" />
                    <p>Initializing cameras…</p>
                </div>
            </div>
        </GlobalOverlayPortal>
    );

    const initErrorDialog = deferTimerUntilInit && initError && (
        <GlobalOverlayPortal>
            <div className="app-global-overlay--fullscreen-backdrop">
                <div
                    style={{
                        backgroundColor: '#fff',
                        padding: '24px',
                        borderRadius: '8px',
                        maxWidth: '400px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                    }}
                >
                    <p style={{ margin: '0 0 16px', color: '#333' }}>{initError}</p>
                    <button
                        className="blue-button"
                        onClick={() => setInitError(null)}
                    >
                        OK
                    </button>
                </div>
            </div>
        </GlobalOverlayPortal>
    );

    return (
            <div>
                {initOverlay}
                {initErrorDialog}
                <div className="assessment-inputs">
                    <div onClick={toggleInstructions} className="toggable">
                        {showInstructions ? <i className="fas fa-caret-down"/> : <i className="fas fa-caret-right"/>}
                        <span>{title}</span>
                    </div>
                    <DisplayButtons
                        title={title}
                        actions={actions}
                        setActions={setActions}
                        deferTimerUntilInit={deferTimerUntilInit}
                        {...(deferTimerUntilInit && {
                            isInitializing,
                            setInitializing,
                            setInitError,
                        })}
                    />
                    <RecordTimer actions={actions} />
                </div>
                <div className="instructions" style={{display: showInstructions ? "inline-block" : "none"}}>
                    <strong>Instructions: </strong>
                    <p>{instructions}</p>
                    <strong>Notes:</strong>
                    <textarea onChange={onChangeNotes}/>
                </div>
        </div>
    )
}

export default RecordAssessment;
